import { IIntCompanyIdentifier } from "factor-lib/Company/IIntCompanyIdentifier";

import { formatCompanyInput } from "factor-lib/Company/companyUtils";

export const formatCompany = (company: { name: string; identifier: IIntCompanyIdentifier; }) =>
    formatCompanyInput(company.identifier, company.name);